import Axios from 'axios'

export default {
  state: {
    invoice: null,
    invoices: []
  },
  getters: {
    INVOICE: state => state.invoice
  },
  mutations: {
    ADD_INVOICE (state, payload) {
      state.invoices.push( payload )
    },
    SET_INVOICE ( state, invoice ) {
      state.invoice = invoice;
    },
  },
  actions: {
    ADD_INVOICE: async ( context, params ) => {
      let { data } = await Axios.post( '/invoices', params );
      context.commit('ADD_INVOICE', typeof(data.result) != 'undefined'? data.result: data);
      return typeof(data.result) != 'undefined'? data.result: data;
    },
    UPDATE_INVOICE ( { commit }, invoice ) {
      commit( 'SET_INVOICE', invoice );
    },
    GET_INVOICE: async ( context, invoiceId ) => {
      context.commit('SET_INVOICE', false);
      let { data } = await Axios.get( '/invoices/' + invoiceId )
      context.commit('SET_INVOICE', typeof(data.result) != 'undefined'? data.result: data);
      return typeof(data.result) != 'undefined'? data.result: data;
    }
  },
}
